module.exports = __webpack_public_path__ + "img/icon_download_desc.2f299a87.png";